import { HttpHeaders } from "@angular/common/http";

export const DEFAULT_JSON_HEADERS = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json'
});

export const DEFAULT_URLENCODED_HEADERS = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
});

export const DEFAULT_FORMDATA_HEADERS = new HttpHeaders({
    'Content-Type': 'multipart/form-data',
    'Accept': 'application/json',
});

export const DEFAULT_PDF_HEADERS = new HttpHeaders({
    'Accept': 'application/json',
});